var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleDraftOutline24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Actions/check_circle_outline_black_24dp Copy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[MVP]-Tablet-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assessments_default_successfully-submitted",
    transform: "translate(-697.000000, -378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(450.000000, 337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/Actions/check_circle_outline_black_24dp-Copy",
    transform: "translate(243.333333, 37.333333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 53.3333337 0 53.3333337 53.3333337 0 53.3333337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666668,4.44444447 C14.4000001,4.44444447 4.44444447,14.4000001 4.44444447,26.6666668 C4.44444447,38.9333336 14.4000001,48.8888892 26.6666668,48.8888892 C38.9333336,48.8888892 48.8888892,38.9333336 48.8888892,26.6666668 C48.8888892,14.4000001 38.9333336,4.44444447 26.6666668,4.44444447 Z M26.6666668,44.4444447 C16.8666668,44.4444447 8.88888894,36.4666669 8.88888894,26.6666668 C8.88888894,16.8666668 16.8666668,8.88888894 26.6666668,8.88888894 C36.4666669,8.88888894 44.4444447,16.8666668 44.4444447,26.6666668 C44.4444447,36.4666669 36.4666669,44.4444447 26.6666668,44.4444447 Z M36.8666669,16.8444445 L22.2222224,31.4888891 L16.4666668,25.7555557 L13.3333334,28.8888891 L22.2222224,37.777778 L40.0000003,20.0000001 L36.8666669,16.8444445 Z",
    id: "Shape",
    fill: "#99CC00",
    fillRule: "nonzero"
  }))))))));
}
export default SvgCheckCircleDraftOutline24Dp;